<template>
    <div class="container max-w-md mx-auto text-center py-6 p-5 pt-10 md:pt-16">
        <div>
            <h2 class="pt-4 pb-2" v-text="$t('DOUBLE_OPT_IN_CONFIRMATION')"></h2>
            <p>
                {{ $t('DOUBLE_OPT_IN_MESSAGE') }}.
            </p>
        </div>
    </div>
</template>
<script>
import PreferencesService from '@/services/users/PreferencesService';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';

export default {
    name: 'DoubleOptInConfirmation',
    data() {
        return {
            errorHandler: new ErrorResponseHandler(),
        };
    },
    created() {
        const userId = this.$route.query.token;

        if (!userId) {
            this.$store.dispatch('account/fetchUserData', true).then(() => {
                this.confirmDoubleOptIn(this.authUser.id);
            });
        } else {
            this.confirmDoubleOptIn(userId);
        }
    },
    computed: {
        authUser() {
            return this.$store.getters['account/getUser'];
        },
    },
    methods: {
        confirmDoubleOptIn(userId) {
            if (userId) {
                new PreferencesService().confirmDoubleOptIn(userId)
                    .then(() => this.$router.push({ name: 'account.dashboard' }))
                    .catch(error => this.errorHandler.setResponse(error && error.response ? error.response.data : ''));
            } else {
                this.$router.push({ name: 'login' });
            }
        },
    },
};
</script>
